import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { EntryState, RootState, getLeague, LoadLeagueOnceAction } from "@play/state";
import { Store } from "@ngrx/store";
import { filter } from "lodash";
import { League, Ranking, RankingEntry } from "@play/api-typings";
import { RankingResource } from "@play/api-client";

@Component({
    selector: "league-winner-contestant",
    templateUrl: "./league-winner-contestant.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueWinnerContestantComponent implements OnChanges {
    public contestant$: BehaviorSubject<RankingEntry> = new BehaviorSubject(null);
    public league$: Observable<EntryState<League>>;

    @Input() public leagueId: number;

    constructor(private store: Store<RootState>, private rankingResource: RankingResource) {}

    public ngOnChanges(): void {
        if (!this.leagueId) {
            return;
        }

        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));

        this.rankingResource
            .getRankingOfLeague(this.leagueId)
            .toPromise()
            .then((ranking: Ranking) => {
                const winners = filter(ranking.ranking, contestant => {
                    const contestantInfo = contestant[ranking.type];

                    if (!contestantInfo) {
                        return false;
                    }

                    const isTrustedOrPremium = contestantInfo.premium || contestantInfo.trustLevel > 0;

                    return contestant.position === 1 && isTrustedOrPremium;
                });

                if (winners.length) {
                    const contestant = winners[Math.floor(Math.random() * winners.length)];
                    this.contestant$.next(contestant);
                }
            });
    }
}
